<template>
  <div class="pts-overview">
    <div v-for="(paragraph, i) in paragraphs" :key="i">
      <p class="pts-overview__body">
        {{ paragraph.text }}
        <strong v-if="paragraph.highlight">{{ paragraph.highlight }}</strong>
      </p>
      <!-- The forms in this survey come back as a list, shown as bullet points. -->
      <ul v-if="paragraph.list && paragraph.list.length" class="pts-overview__list">
        <li v-for="item in paragraph.list" :key="item">
          <strong>{{ item }}</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// Copy is composed by the API from whichever sections the booking has.
export default {
  props: {
    overview: { type: Object, default: null },
  },
  computed: {
    paragraphs() {
      return (this.overview && this.overview.paragraphs) || []
    },
  },
}
</script>
